export default __webpack_public_path__ + "static/media/overall_head.0d7d0881.jpg";